import { getCurrencyPrecision } from '@core/helpers/currency'

import { SOURCES } from './RecommendationBundle.constants'

export const productToBundle = (product, activeGrade, priceFormatter) => {
  return {
    grade: activeGrade.backboxGrade.name,
    id: activeGrade.id,
    imageUrl: product.images?.[0]?.url,
    price: {
      display: priceFormatter(activeGrade.price),
      raw: activeGrade.price,
    },
    referencePrice: {
      display: priceFormatter(product.priceWhenNew),
      raw: product.priceWhenNew,
    },
    subTitle: (product.subTitleElements || []).join(' - '),
    title: product.title,
    source: SOURCES.PRODUCT_PAGE,
  }
}

export const recommendationToBundle = (product, priceFormatter) => {
  return {
    grade: product.listing.grade.name,
    id: product.listing.id,
    imageUrl: product.images?.[0],
    price: {
      display: priceFormatter(product.listing.price),
      raw: product.listing.price,
    },
    referencePrice: {
      display: priceFormatter(product.referencePrice),
      raw: product.referencePrice,
    },
    subTitle: (product.subtitles || []).join(' - '),
    title: product.title,
    url: product.link.href,
    source: SOURCES.RECOMMENDATION_API,
    productId: product.id,
  }
}

export const getTotalPrice = (listings, priceFormatter) => {
  const amounts = listings.map((listing) =>
    parseFloat(listing.price?.raw?.amount),
  )

  if (amounts.includes(NaN)) {
    throw new Error(
      'Failed to compute bundle total price: invalid listing price',
      {
        listings,
      },
    )
  }

  const { currency } = listings[0].price.raw
  const totalAmount = amounts
    .reduce((total, amount) => total + amount, 0)
    .toFixed(getCurrencyPrecision(currency))

  const raw = {
    amount: totalAmount,
    currency,
  }

  return {
    display: priceFormatter(raw),
    raw,
  }
}
